// extracted by mini-css-extract-plugin
module.exports = {"CMSContent":"style_CMSContent__L6ZL9","content":"style_content__hi6T9"};